// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","footerTitle":"footer-module--footerTitle--13HFI","split":"footer-module--split--1hdz3"};